import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  IsSmallScreen,
  MasterPages,
  Method
} from "../../../commonFunctions/CommonFunctions";
import {
  getPermissions,
  IPermission
} from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, {
  IOrderColumns
} from "../../../Components/DataGrid/WSMobileDataGridAdvanced";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useDispatch } from "react-redux";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import { UpdateStatus } from "../../UpdateStatus";

export const LeadList: React.FC<any> = React.memo((props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getLeadPermission;
  const [leadListData, setLeadlistData] = useState<any>([]);

  const { showMessage } = useSnackbar();
  const isMobile = IsSmallScreen();
  const [rowId, setRowId] = useState<any>(null);
  //  const [permission,setPermissions]=useState<IPermission>({add:false,edit:false,view:false})
  //  useEffect(()=>{
  //    const { edit, view, add } = getPermissions(MasterPages.Leads);
  //    setPermissions({edit, view, add})

  //  },[])

  useEffect(() => {
    if (rowId) {
      openPopUp(metadataStatus, handleStatus, "40rem", handleCloseDialog);
    }
  }, [rowId]);

  const source = {
    url: "leads/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "leadType",
        operator: "eq",
        value: "0"
      }
    ],
    sort: []
  };

  /**
   * Edit function
   * @param action
   * @param row
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/leads/edit/${row?.id}`);
    } else if (action === "Convert to Contact") {
      const response = await convertToLead(row?.id);
      if (response?.message) {
        showMessage(
          response?.message || "Converted to Contact successfully!",
          "success"
        );
         dispatch(resetDataComponent("leadGrid"));
        const data: any = leadListData.filter(
          (item: any) => item.leadType === 0
        );
        setLeadlistData(data);
      } else {
        showMessage(response?.message || "Something went wrong", "error");
      }
    } else if (action === "Change Status") {
      setRowId(row?.id);
    }  else if (action === 'Add Site Visit') {
      navigate(`/visit/${row?.id}/date/${row?.statusChagedAt}`);
    }
  };

  const handleStatus = async (data: any) => {
    try {
      const response: any = await saveData(data);
      console.log("response from put lead is", response);
      setRowId(null);

      if (response && response.message) {
        dispatch(resetDataComponent("leadGrid"));
        showMessage(
          response.message || "Status updated successfully!",
          "success"
        );
      }
    } catch (e: any) {
      showMessage(e.error, "error");
    } finally {
      setRowId(null);
    }
  };

  const handleCloseDialog = (data?: any) => {
    setRowId(null);
  };

  const saveData = async (data: any) => {
    console.log('daa is',data)
    const request: any = {
      Status: data?.newStatus || ""
      // leadStatusId: data?.status || "",
    };
    console.log('request is',request)
    const response: any = await callAPI(`leads`, Method.PUT, request, rowId);
    return response;
  };

  const convertToLead = async (id: string) => {
    const response: any = await callAPI(`leads`, Method.PUT, {
      LeadType: 1
    },id);
    if (response) {
      return response;
    }
    return false;
  };

  const metadataStatus: IMetaData = {
    title: "Update Status",
    hideActions: false,
    content: (props: any, row: any) => <UpdateStatus {...props}/>,
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button"
      },
      {
        label: "Submit",
        onClick: handleStatus,
        type: "submit",
        autoFocus: true
      }
    ],
    isDragable: true
  };

  const columns: IColumns[] = [
    {
      header: "Company",
      fieldName: "company",
      type: "default"
    },
    {
      header: "Full Name",
      fieldName: "fullName",
      type: "default"
      //  sortable: true
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default"
    },
    {
      header: "Mobile",
      fieldName: "mobile",
      tooltip: true,
      isHide: isMobile,
      type: "default"
    },
    {
      header: "status",
      fieldName: "status",
      tooltip: true,
      type: "status"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [
        edit ? "Edit" : undefined,
        "Convert to Contact",
        "Change Status",
        "Add Site Visit"
      ].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
      fieldCompare: {
        fieldName: "leadType",
        ValueCheck: { value: 1, actionCheck: "Convert to Contact" }
      },
        hideSelectedActions: {
                // fieldToHide: [
                //     {
                //         field: 'status',
                //         hideValue: ['Contacted','New','Converted','Lost','Estimated'],
                //         hideActions: ['Add Site Visit']
                //     },
                //     // {
                //     //     field: 'status',
                //     //     hideValue: ['Completed'],
                //     //     hideActions:  ['Reject','Approve']
                //     // }
                // ],
                fieldToShow:[
                  {
                       field: 'status',
                        showValue: ['Qualified'],
                        showActions: ['Add Site Visit']
                  }
                ]
            },
    }
  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Full Name",
      fieldName: "fullName",
      labelSx: { fontWeight: "bold" },
      type: "default",
      sm: 6
      // otherFiels:[{fieldName:'email' ,type:'default'}]
      //  sortable: true
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default",
      sm: 6
    },
    {
      header: "Company",
      fieldName: "company",
      type: "default",
      sm: 6
    },

    {
      header: "Mobile",
      fieldName: "mobile",
      tooltip: true,
      sm: 6,
      type: "default"
    },

    {
      header: "Created On",
      fieldName: "createdAt",
      sm: 4,
      isBoderRadious: true,
      type: "date"
    },
    {
      header: "Updated On",
      fieldName: "uptAt",
      sm: 4,
      isBoderRadious: true,
      type: "date"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      sm: 4,
      actions: ["Edit", "Convert to Contact"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];
  const handleClick = () => {
    navigate("/leads/create");
  };

  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.fullName = `${item?.firstName} ${
          item?.lastName ? item?.lastName : ""
        }`;
      });
      return data;
    }
  };
  
  return (
    <>
      <Grid container spacing={2}>
        {view ? (
          <Grid item xs={12}>
            {!isMobile && (
              <WSDataGrid
                id="leadGrid"
                title="Leads"
                columns={columns}
                source={source}
                transFormData={transFormData}
                addButton={
                  add ? { label: "New", color: "secondary" } : undefined
                }
                onAddButtonClick={handleClick}
                searchBox={{ fieldName: "firstName,company,lastName,mobile" }}
                gridHeaderSx={{
                  backgroundColor: "whitesmoke",
                  border: "1px solid whitesmoke"
                }}
              />
            )}
            {isMobile && (
              <WSMobileDataGridAdvanced
                transFormData={transFormData}
                title={"Leads"}
                addButton={
                  add ? { label: "New", color: "secondary" } : undefined
                }
                onAddButtonClick={handleClick}
                columns={mobColumns}
                id="leadGrid"
                source={source}
              />
            )}
          </Grid>
        ) : (
          <PermissionDenied />
        )}
      </Grid>
    </>
  );
});
